module.exports = __webpack_public_path__ + "media/images/badges/rowhouse/4-5mill-active-498dcb5bb51644e6ff180397d243f36a.png";